export default __webpack_public_path__ + "static/GreycliffCF-Bold-bf92e749965788179fa70213415f17e6.woff2";